export const coachRating = {
  title: "Record Match",
  opponent: "Opponent",
  opponentPlaceholder: "Search opponent by @handle or name…",
  matchType: {
    friendly: "Friendly",
    ranked: "Ranked",
    tournament: "Tournament",
  },
  // Legacy plural alias kept for back-compat with any old imports.
  matchTypes: {
    friendly: "Friendly",
    club: "Club Match",
    tournament: "Tournament",
  },
  set: "Set",
  you: "You",
  addSet: "Add Set",
  matchResult: "Match Result",
  victory: "Victory!",
  keepPracticing: "Keep practicing!",
  saveMatch: "Save Match",
  saving: "Saving...",
  validation: {
    opponentRequired: "Please pick an opponent first.",
  },
};
